import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { DollarSign, Zap, TrendingUp, Shield } from "lucide-react";
export const SmallSchoolValueProp = () => {
  return <div className="py-16 bg-gradient-to-b from-background to-muted/50">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">
            Built for Div II, Div III, NAIA, and High Schools
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Affordable NIL compliance that doesn't require an IT team or months of
            setup. Start protecting your program in 48 hours.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4 mb-12">
          <Card>
            <CardHeader>
              <DollarSign className="h-10 w-10 text-primary mb-2" />
              <CardTitle>Affordability</CardTitle>
              <CardDescription>
                Starting at $5K/year or $50 per athlete
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                No hidden fees. No long-term contracts. Cancel anytime.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <Zap className="h-10 w-10 text-primary mb-2" />
              <CardTitle>Simplicity</CardTitle>
              <CardDescription>
                No IT team needed — up and running in 48 hours
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Cloud-based platform works on any device. Zero installation required.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <TrendingUp className="h-10 w-10 text-primary mb-2" />
              <CardTitle>Monetization</CardTitle>
              <CardDescription>
                Help your athletes earn while staying compliant
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Built-in marketplace connects athletes with brand opportunities.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <Shield className="h-10 w-10 text-primary mb-2" />
              <CardTitle>Risk Mitigation</CardTitle>
              <CardDescription>
                AI-powered compliance prevents violations before they happen
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Automated alerts keep you ahead of changing state and NCAA rules.
              </p>
            </CardContent>
          </Card>
        </div>

        <Card className="bg-primary/10 border-primary/20">
          <CardContent className="p-8">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold mb-4">Case Study: Mid-Major Success</h3>
                <blockquote className="italic text-muted-foreground mb-4">
                  "We went from manually reviewing deals in Excel to automated compliance
                  in under a week. The platform paid for itself after preventing just one
                  NCAA violation."
                </blockquote>
                <div className="space-y-2 text-sm">
                  <p className="font-semibold">— Sarah Mitchell</p>
                  <p className="text-muted-foreground">
                    Compliance Officer, Mid-Atlantic D2 University
                  </p>
                </div>
              </div>
              <div className="space-y-4">
                <div className="flex justify-between items-center p-3 bg-background rounded-lg">
                  <span className="text-sm">Deals Processed</span>
                  <span className="text-2xl font-bold">87</span>
                </div>
                <div className="flex justify-between items-center p-3 bg-background rounded-lg">
                  <span className="text-sm">Violations Prevented</span>
                  <span className="text-2xl font-bold">5</span>
                </div>
                <div className="flex justify-between items-center p-3 bg-background rounded-lg">
                  <span className="text-sm">Time Saved</span>
                  <span className="text-2xl font-bold">15h/week</span>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        <div className="text-center mt-12">
          
          <p className="text-sm text-muted-foreground mt-4">
            Join 50+ smaller schools already using the platform
          </p>
        </div>
      </div>
    </div>;
};